import { Imatge, getImatge } from '@portal-internet/components';
import {
    getCaducitat,
    getDurada,
    getFormatData,
    getHora,
    hasEtiquetaDocumental,
    isPeli,
    removeHtmlTags,
    trimBR
} from '@portal-internet/core';
import clsx from 'clsx';
import CodiEspectador from 'components/3cat/CodiEspectador';
import Compartir from 'components/3cat/Compartir';
import Player from 'components/3cat/Player';
import AfegeixALaLlista from 'components/3cat/ui/AfegeixALaLlista';
import Boto from 'components/ui/Boto';
import Icona from 'components/3cat/ui/Icona';
import LogoDirecte from 'components/3cat/ui/LogoDirecte';
import InnerHTML from 'dangerously-set-html-content';
import { useEstasVeient } from 'hooks/3cat/useEstasVeient';
import useStartOverHelper from 'hooks/useStartOverHelper';
import { typesViewport, useViewport } from 'hooks/useViewport';
import __isEmpty from 'lodash/isEmpty';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import styles from './itemvideo.module.scss';

const _getSubtitols = (subtitolsApi, mediaModel) => {
    let result;
    const mediaSubtitles = mediaModel?.attributes?.subtitols?.map((subtitol) => subtitol.attributes.text) || [];
    const text = __isEmpty(mediaSubtitles) ? [] : mediaSubtitles;

    if (subtitolsApi && __isEmpty(mediaSubtitles)) {
        // català
        result = subtitolsApi.filter((subtitol) => subtitol.id === 'CAT_CA');
        if (!__isEmpty(result)) {
            text.push('català');
        }

        // castellà
        result = subtitolsApi.filter((subtitol) => subtitol.id === 'CAT_ES');
        if (!__isEmpty(result)) {
            text.push('castellano (traducción automática)');
        }

        // anglès
        result = subtitolsApi.filter((subtitol) => subtitol.id === 'CAT_EN');
        if (!__isEmpty(result)) {
            text.push('English (automatic translation)');
        }

        // francès
        result = subtitolsApi.filter((subtitol) => subtitol.id === 'CAT_FR');
        if (!__isEmpty(result)) {
            text.push('Français (traduction automatique)');
        }
    }

    return text.length === 0 ? false : 'Subtítols en: ' + text.toString().replaceAll(',', ' / ');
};

const _getAudioDescripcio = (props) => {
    let result = false;

    if (!__isEmpty(props)) {
        result = props.filter((audiodescripcio) => audiodescripcio.id === 'AUD');
    }
    return result;
};

const _isCaducat = (endPubDate) => {
    const dataAra = new Date();
    if (getFormatData(endPubDate) < dataAra) {
        return true;
    }
    return false;
};

const VideoDisponible = (props) => {
    const { state, endPubDate } = props;

    if (state === 'DESP' && endPubDate) {
        return (
            <div className={styles.noDisponible} data-testid='item-despublicat'>
                <Icona icona='avis' alt='avis' mida={28} />
                <div className={styles.outertext}>Aquest vídeo està despublicat</div>
            </div>
        );
    }

    if (_isCaducat(endPubDate)) {
        return (
            <div className={styles.noDisponible} data-testid='item-despublicat'>
                <Icona icona='avis' alt='avis' mida={28} />
                <div className={styles.outertext}>Aquest vídeo està caducat</div>
            </div>
        );
    }

    return <></>;
};

const MirahoPrincipi = (props) => {
    const { isVideoResumed, player } = props;
    if (!isVideoResumed) return <></>;

    const textBoto = 'DES DEL PRINCIPI';
    const iconaBoto = 'hascomencat';

    return (
        <Boto
            text={textBoto}
            icona={iconaBoto}
            className={styles.mirahoPrincipi}
            estil='transparent'
            mida='s'
            iconaInline={true}
            isIconaDreta={false}
            tag='button'
            onClick={() => player.current.play()}
        />
    );
};

const MiraStartOver = (props) => {
    const { onButtonClick } = props;
    const textBoto = 'DES DEL PRINCIPI';
    const iconaBoto = 'hascomencat';

    return (
        <Boto
            dataTestId={'boto-mira-principi'}
            text={textBoto}
            icona={iconaBoto}
            className={styles.mirahoPrincipi}
            estil='transparent'
            mida='s'
            iconaInline={true}
            isIconaDreta={false}
            tag='button'
            onClick={onButtonClick}
        />
    );
};

const TornaDirecte = (props) => {
    const { onButtonClick } = props;
    const textBoto = 'TORNA AL DIRECTE';
    const iconaBoto = 'hascomencat';

    return (
        <Boto
            dataTestId={'boto-torna-directe'}
            text={textBoto}
            icona={iconaBoto}
            className={styles.mirahoPrincipi}
            estil='transparent'
            mida='s'
            iconaInline={true}
            isIconaDreta={false}
            tag='button'
            onClick={onButtonClick}
        />
    );
};

const Etiqueta = (props) => {
    const { isPelicula, isDocumental, avantitol, hasPrograma } = props;

    return (
        <>
            {isPelicula && (
                <p className={styles.peli} aria-label='Pel·lícula'>
                    Pel·lícula
                </p>
            )}
            {!isPelicula && isDocumental && (
                <p className={styles.peli} aria-label='Documental'>
                    Documental
                </p>
            )}
            {!isPelicula && !isDocumental && !hasPrograma && avantitol && (
                <p className={styles.peli} aria-label={avantitol}>
                    {avantitol}
                </p>
            )}
        </>
    );
};

export default function Itemvideo(props) {
    const {
        autoPlay,
        avantitol,
        canal,
        canalLogo,
        codiEspectador,
        cos,
        dataCaducitat,
        dataModificacio,
        dataPublicacio,
        despresHora,
        despresPrograma,
        despresTitol,
        directe,
        durada,
        embed,
        endPubDate,
        formats,
        id,
        imatges,
        isWebviewActive,
        logo,
        mostraH1,
        parametresExtraWs,
        sinopsi,
        state,
        subtitols,
        tematica,
        tipologia,
        tipus,
        tipusContingut,
        titol,
        titolPrograma,
        variants,
        versio
    } = props;

    const entradeta = trimBR(props.entradeta);
    const entradetaPromo = trimBR(props.entradetaPromo);
    const [infoTitol, setInfoTitol] = useState(false);
    const [infoDespresPrograma, setInfoDespresPrograma] = useState(false);
    const [infoDespresTitol, setInfoDespresTitol] = useState(false);
    const [infoDespresHora, setInfoDespresHora] = useState(false);
    const [isDesplegat, setIsDesplegat] = useState(false);
    const [hideInfo, setHideInfo] = useState(false);
    const [botoAd, setBotoAd] = useState(false);
    const [audioDesc, setAudioDesc] = useState(false);
    const [textAud, setTextAud] = useState('Activa');
    const [textSRAud, setTextSRAud] = useState('Vés a la versió amb');
    const { isVideoResumed } = useEstasVeient({ durada, id });
    const { viewport } = useViewport();
    const [hasStartoverData, sethasStartoverData] = useState();
    const [error, setError] = useState(false);
    const [mediaModel, setMediaModel] = useState(null);
    const [isOtt, setIsOtt] = useState(false);
    const [showSubtitles, setShowSubtitles] = useState(null);
    const { getHashParamsFromUrl } = useStartOverHelper();
    const router = useRouter();

    const { hashStartOverParams } = getHashParamsFromUrl(router.asPath.split('#')[1]);
    const isStartOver = hashStartOverParams?.so_id !== undefined;

    const mostrarCaducitat = dataCaducitat && getCaducitat(dataCaducitat);
    const mostrarDataActualitzacio =
        dataPublicacio && !['PUFIC_HUMOR', 'PUFICCIO'].includes(tematica) && ['PPW', 'PPD', 'CLIP_PPD'].includes(tipusContingut);
    const isPelicula = isPeli(formats);
    const isDocumental = hasEtiquetaDocumental(formats, isPelicula, titolPrograma, false, tipologia);
    const audiencies = {
        tipologia: tipologia,
        titol: titol,
        programa: titolPrograma,
        url: router.asPath,
        durada: durada
    };
    const botoDesplegable = useRef();
    const textDesplegable = useRef();
    const textMeasurer = useRef();
    const playerRef = useRef();

    const [esAniversari, setIsAniversari] = useState(false);
    
    const isAniversariFromUrl = () => {
    if (typeof window === 'undefined') return false;
        const urlParams = new URLSearchParams(window.location.search);
        const agrupacio = urlParams.get('agrup');
        return agrupacio ? agrupacio.startsWith('PUAG_ANIV') : false;
    };

    useEffect(() => {
        setIsAniversari(isAniversariFromUrl());
        console.log('esAniversari:', esAniversari);
    }, [router.query]);

    const stylesInfo = clsx({
        [styles.info]: true,
        [styles.directe]: directe,
        [styles.hide]: hideInfo
    });

    const stylesItem = clsx({
        [styles.itemvideo]: true,
        [styles.hide]: hideInfo
    });

    const stylesVideo = clsx({
        [styles.video]: true
    });

    const stylesArticle = clsx({
        [styles.aniversari]: esAniversari
    });

    const stylesBotoAudiodescripcio = clsx({
        [styles.boto]: true,
        [styles.hideBotoAd]: !botoAd
    });

    const stylesContentInfo = clsx({
        [styles.contentInfo]: viewport === typesViewport.VP_LARGE
    });

    const stylesWrapperEntradeta = clsx({
        [styles.wrapperEntradeta]: true,
        [styles.desplegat]: isDesplegat
    });

    const ocultaInfo = (estat) => {
        setHideInfo(estat);
    };

    const showBotoAd = (estat) => {
        setBotoAd(estat);
    };

    const updateInfo = (dades) => {
        setInfoTitol(dades.titol_complet);
        setInfoDespresPrograma(dades.despresPrograma);
        setInfoDespresTitol(dades.despresTitol);
        setInfoDespresHora(dades.despresHora);
        sethasStartoverData(dades.startOverParams || undefined);
    };

    const updateAudioDesc = () => {
        setAudioDesc(!audioDesc);
        let textAud = audioDesc ? 'Activa' : 'Desactiva';
        let textSRAud = audioDesc ? 'Vés a la versió amb' : 'Vés a la versió sense';
        setTextAud(textAud);
        setTextSRAud(textSRAud);
    };

    const desactivaAudioDesc = () => {
        setAudioDesc(false);
        setTextAud('Activa');
        setTextSRAud('Vés a la versió amb');
    };

    const changeAudioDesc = () => {
        updateAudioDesc();
        playerRef.current.handleAudioDesc(audioDesc);
    };

    const desplegaText = () => {
        setIsDesplegat(true);
        let transitionDuration = (textDesplegable.current.scrollHeight - 72) / 240;
        textDesplegable.current.style.transitionDuration = transitionDuration + 's';
        textDesplegable.current.style.height = textDesplegable.current.scrollHeight + 'px';
        botoDesplegable.current.style.display = 'none';
        setTimeout(() => {
            textDesplegable.current.style.height = 'auto';
        }, transitionDuration * 1000);
    };

    const isError = (error) => {
        setError(error);
    };

    const pushMediaModel = (mediaModel) => {
        setMediaModel(mediaModel);
    };

    useEffect(() => {
        if (!isPelicula && entradeta && !directe) {
            function calculaMes() {
                // comprobem la posició de l'últim caràcter de la tercera línia, i si cal, movem el botó "més"
                if (
                    textMeasurer.current.offsetTop < textDesplegable.current.clientHeight &&
                    textDesplegable.current.clientWidth - textMeasurer.current.clientWidth - textMeasurer.current.offsetLeft >
                        botoDesplegable.current.clientWidth - 35
                ) {
                    botoDesplegable.current.style.left =
                        Math.min(
                            textMeasurer.current.offsetLeft - 20,
                            textDesplegable.current.clientWidth - botoDesplegable.current.clientWidth
                        ) + 'px';
                } else {
                    botoDesplegable.current.style.left = 'auto';
                }

                if (!__isEmpty(textDesplegable.current)) {
                    if (textDesplegable.current.scrollHeight > textDesplegable.current.clientHeight + 5) {
                        botoDesplegable.current.style.display = 'block';
                    } else {
                        botoDesplegable.current.style.display = 'none';
                    }
                }
            }
            if (!directe) {
                calculaMes();
                window.addEventListener('resize', calculaMes);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!__isEmpty(mediaModel)) {
            setShowSubtitles(_getSubtitols(subtitols, mediaModel));
            const mediaNodeUrl = mediaModel?.attributes?.media?.models[0]?.attributes.url[0].ott;
            setIsOtt(mediaNodeUrl);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mediaModel]);

    const _hasLogo = Boolean(getImatge(logo, 'web_logo', null, null));

    const compositeKey = directe ? `${id}-${hashStartOverParams?.start}` : 'VoD';

    return (
        <article className={stylesArticle}>
            {_getAudioDescripcio(variants) && !isOtt && (
                <div className='sr-only'>
                    <button className={styles.boto} onClick={changeAudioDesc}>
                        {textSRAud} audiodescripció de {titolPrograma} {titolPrograma && <>-</>} {infoTitol || titol}
                    </button>
                </div>
            )}
            <div className={stylesItem}>
                <div className={stylesVideo}>
                    {state != 'DESP' && !_isCaducat(endPubDate) && !error && <div className={styles.loader}></div>}
                    <Player
                        key={compositeKey}
                        ref={playerRef}
                        id={id}
                        autoPlay={autoPlay}
                        directe={directe}
                        hashStartOverParams={hashStartOverParams}
                        isStartOver={isStartOver}
                        versio={versio}
                        parametresExtraWs={parametresExtraWs}
                        tipus={tipus}
                        className={styles.rmp}
                        ocultaInfo={ocultaInfo}
                        showBotoAd={showBotoAd}
                        updateInfo={updateInfo}
                        updateAudioDesc={updateAudioDesc}
                        desactivaAudioDesc={desactivaAudioDesc}
                        pushMediaModel={pushMediaModel}
                        state={state}
                        endPubDate={endPubDate}
                        playerError={isError}
                        imatges={imatges}
                        variantsAD={variants}
                    ></Player>
                </div>
                <div className={stylesContentInfo}>
                    <div className={stylesInfo} data-testid='info-video'>
                        {!directe && <VideoDisponible state={state} endPubDate={endPubDate} />}
                        {directe && (
                            <div className={styles.etiDirecte}>
                                <div>
                                    <Icona
                                        icona='directes'
                                        isBlanc={true}
                                        className={styles.icoEtiDirecte}
                                        alt='Icona directes'
                                    ></Icona>
                                    <span>En directe</span>
                                </div>
                            </div>
                        )}
                        {directe && <LogoDirecte canal={canal} logo={canalLogo} className={styles.imgLogoCanal} />}
                        {_hasLogo && !directe && (
                            <div className={styles.logoItemVideo}>
                                <Imatge
                                    imatges={logo}
                                    tipus='web_logo'
                                    layout='fill'
                                    objectFit='contain'
                                    mostrarRecurs={false}
                                    alt={titolPrograma}
                                />
                            </div>
                        )}
                        {!_hasLogo && titolPrograma && !isPelicula && (
                            <div className={styles.titolSenseLogo}>{titolPrograma}</div>
                        )}
                        <Etiqueta
                            isPelicula={isPelicula}
                            isDocumental={isDocumental}
                            avantitol={avantitol}
                            hasPrograma={!__isEmpty(titolPrograma)}
                        />
                        {titol && !directe && (
                            <div className={styles.titolWrapper}>
                                {mostraH1 ? <h1 className={styles.titol}>{titol}</h1> : <h2 className={styles.titol}>{titol}</h2>}
                            </div>
                        )}

                        {!directe && (
                            <div className={styles.sharing}>
                                <MirahoPrincipi isVideoResumed={isVideoResumed} player={playerRef} />
                                <AfegeixALaLlista
                                    className={styles.afegirLlista}
                                    tooltipPosition='topright'
                                    id={id}
                                    tipologia={tipologia}
                                    audiencies={audiencies}
                                />
                                <Compartir
                                    className='icona_compartir'
                                    titol={infoTitol || titol}
                                    mostraEmbed={embed}
                                    isWebviewActive={isWebviewActive}
                                />
                            </div>
                        )}
                        {isPelicula && entradetaPromo && (
                            <p className={styles.entradetaPromo} data-testid='info-entradeta'>
                                {removeHtmlTags(entradetaPromo)}
                            </p>
                        )}
                        {!isPelicula && !directe && entradetaPromo && (
                            <p className={styles.entradetaPromo} data-testid='info-entradeta'>
                                {removeHtmlTags(entradetaPromo)}
                            </p>
                        )}

                        {(codiEspectador || durada || dataCaducitat || dataPublicacio) && (
                            <div className={styles.subinfo}>
                                {codiEspectador && !directe && (
                                    <CodiEspectador
                                        codi={codiEspectador[0].id}
                                        alt={codiEspectador[0].desc}
                                        mida='20'
                                        className={styles.ico_codi}
                                    />
                                )}

                                <div className={styles.durada}>
                                    {!__isEmpty(durada) && (
                                        <>
                                            <Icona
                                                className={styles.ico_clock}
                                                icona='rellotge'
                                                isBlanc={true}
                                                mida='13'
                                                alt='Icona rellotge'
                                                ariaHidden={true}
                                            />
                                            <div>
                                                <span className='sr-only'>Durada: </span>
                                                {getDurada(String(durada))}
                                            </div>
                                        </>
                                    )}
                                </div>
                                {mostrarDataActualitzacio && (
                                    <div data-testid='item-video-data-publicacio' className={styles.pubdate}>
                                        {dataPublicacio.split(' ').shift()}
                                    </div>
                                )}
                                {mostrarCaducitat && (
                                    <div data-testid='item-video-data-caducitat' className={styles.pubdate}>
                                        {getCaducitat(dataCaducitat)}
                                    </div>
                                )}
                            </div>
                        )}

                        {(titol || infoTitol) && directe && (
                            <div className={styles.titolWrapper}>
                                {mostraH1 ? (
                                    <h1 className={styles.titol}>{infoTitol || titol}</h1>
                                ) : (
                                    <h2 className={styles.titol}>{infoTitol || titol}</h2>
                                )}
                            </div>
                        )}
                        {codiEspectador && directe && (
                            <div className={styles.subinfo}>
                                <CodiEspectador
                                    codi={codiEspectador}
                                    alt={codiEspectador}
                                    mida='20'
                                    className={styles.ico_codi}
                                />
                            </div>
                        )}
                        <div className={styles.subtitolsAD}>
                            {_getAudioDescripcio(variants) && !isOtt && (
                                <div className={styles.botons}>
                                    <button
                                        data-testid='item-video-audiodescripcio'
                                        className={stylesBotoAudiodescripcio}
                                        onClick={changeAudioDesc}
                                    >
                                        <div className={styles.boto_text}>
                                            {textAud} <span className='sr-only'>audiodescripció</span>
                                        </div>
                                        <Icona estil='clickable' alt='Icona audiodescripció' icona='audiodescripcio' />
                                    </button>
                                </div>
                            )}

                            {!__isEmpty(showSubtitles) && (
                                <>
                                    <div className={styles.subtitols}>
                                        <CodiEspectador codi='Subtitols' alt='icona subtítols' mida='20' />
                                        <p className={styles.txt_subtitols}>{showSubtitles}</p>
                                    </div>
                                </>
                            )}
                        </div>
                        {directe && hasStartoverData && !isStartOver && (
                            <MiraStartOver onButtonClick={() => playerRef.current.activaStartOver(true)} />
                        )}
                        {directe && isStartOver && (
                            <TornaDirecte onButtonClick={() => playerRef.current.activaStartOver(false)} />
                        )}
                        {directe && (infoDespresPrograma || despresPrograma || infoDespresTitol || despresTitol) && (
                            <div className={styles.continuacio}>
                                <Icona
                                    className={styles.ico_continuacio}
                                    alt='icona a continuació'
                                    icona='continuacio'
                                    mida={15}
                                />
                                <span>A continuació: </span>
                                <div>
                                    <span>{getHora(infoDespresHora || despresHora)} </span>
                                    <strong>{infoDespresPrograma || despresPrograma}</strong>
                                </div>
                                <span>{infoDespresTitol || despresTitol}</span>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {isPelicula && (entradeta || sinopsi) && (
                <div className={styles.sinopsi}>
                    {entradeta && (
                        <div className={styles.sinopsi_entradeta}>
                            <p>
                                <InnerHTML html={entradeta} />
                            </p>
                        </div>
                    )}
                    {sinopsi && <InnerHTML className={styles.sinopsi_text} html={sinopsi} />}
                </div>
            )}

            {!isPelicula && entradeta && !directe && (
                <div className={stylesWrapperEntradeta}>
                    <div className={styles.entradeta} ref={textDesplegable}>
                        <div className={styles.cutText}>
                            <InnerHTML html={entradeta} data-testid='cuttext-entradeta' className={styles.textEntradeta} />
                            <span className={styles.measurer} ref={textMeasurer}></span>
                            <button className={styles.mes} ref={botoDesplegable}>
                                … <span onClick={() => desplegaText()}>Més</span>
                            </button>
                        </div>
                        {cos && (
                            <div>
                                <InnerHTML html={cos} />
                            </div>
                        )}
                    </div>
                </div>
            )}
        </article>
    );
}

Itemvideo.defaultProps = {
    titol: '',
    programa: '',
    mostraH1: true,
    isWebviewActive: false,
    tipusContingut: null
};
